module.exports = __webpack_public_path__ + "static/favicon-5bc02c9ff56bfd8827fec5384ba23bff.png";